@if (loaded()) {
  <div id="hunt-details-page-wrapper">
    <div class="page-header">
      <div class="left">
        <hyperkit-breadcrumb-list
          class="breadcrumb-list"
          [items]="breadcrumbs()"
        ></hyperkit-breadcrumb-list>
        <div>
          <hyperkit-typography variant="h2" display="inline">
            {{ huntView.name() }}
          </hyperkit-typography>
          @if (huntView.totalHuntQueries() > 0) {
            <hyperkit-segmented-progress-bar
              [segments]="huntView.huntProgressSegments()"
              [showLabels]="true"
              size="small"
            ></hyperkit-segmented-progress-bar>
          }
        </div>
        <div class="meta-data-tags">
          <hyperkit-badge
            [variant]="huntView.priorityVariant()"
            size="base"
            indicator="none"
            [text]="huntView.priority()"
          ></hyperkit-badge>
          <hyperkit-badge
            [variant]="huntView.statusVariant()"
            size="base"
            indicator="none"
            textLeft="Status"
            [text]="huntView.status()"
          ></hyperkit-badge>
          @if (huntView.outcome()) {
            <hyperkit-badge
              [variant]="huntView.outcomeVariant()"
              size="base"
              indicator="none"
              textLeft="Outcome"
              [text]="huntView.outcome()"
            ></hyperkit-badge>
          }
          <hyperkit-tag
            mode="outline"
            [closable]="false"
            textLeft="Created"
            [text]="huntView.createdDate()"
          >
          </hyperkit-tag>
          <hyperkit-tag
            mode="outline"
            [closable]="false"
            textLeft="Last Modified"
            [text]="huntView.lastModified()"
          >
          </hyperkit-tag>
          <hyperkit-tag
            mode="outline"
            [closable]="false"
            textLeft="Author"
            [text]="huntView.assigneeFullName()"
          >
          </hyperkit-tag>
          <hyperkit-tag
            mode="outline"
            [closable]="false"
            textLeft="Author"
            [text]="huntView.authorFullName()"
          >
          </hyperkit-tag>
          @if (huntView.hasHuntTemplate()) {
            <hyperkit-tag
              [routerLink]="'/hunt/hunt-template/' + huntView.huntTemplateId()"
              icon="link-2"
              mode="fill"
              [closable]="false"
              textLeft="Template"
              [text]="huntView.huntTemplateName()"
            >
            </hyperkit-tag>
          }
        </div>
      </div>
      <div class="right">
        @if (error) {
          <hyperkit-error [error]="error"></hyperkit-error>
        }
        <hyperkit-button
          variant="standard"
          color="secondary"
          size="small"
          text="Reopen"
          (click)="reopenHunt()"
          icon="arrow-left"
          iconPosition="left"
        ></hyperkit-button>
        <hyperkit-button-menu
          variant="standard"
          iconPosition="right"
          color="secondary"
          size="small"
          icon="download"
          text="Export"
        >
          <hyperkit-dropdown-menu-item
            value="archive"
            (click)="exportPdf()"
            label="PDF"
          ></hyperkit-dropdown-menu-item>
          <hyperkit-dropdown-menu-item
            value="update"
            label="Word"
            (click)="exportWord()"
          ></hyperkit-dropdown-menu-item>
        </hyperkit-button-menu>
        <hyperkit-button-menu
          variant="icon"
          color="secondary"
          size="medium"
          icon="menu"
          (itemSelected)="handleMenuAction($event)"
        >
          <hyperkit-dropdown-menu-item
            value="update"
            label="Update Hunt Details"
          ></hyperkit-dropdown-menu-item>
          <hyperkit-dropdown-menu-item
            value="archive"
            label="Archive"
          ></hyperkit-dropdown-menu-item>
        </hyperkit-button-menu>
      </div>
    </div>
    <div class="page-content">
      <div id="report">
        <div id="report-header">
          <div id="report-title">
            <hyperkit-typography variant="h5"
              >Threat Hunt Report</hyperkit-typography
            >
          </div>
          <div id="report-list">
            <div class="report-container">
              @for (section of sections(); track section) {
                <hyperkit-report-section
                  [section]="section"
                  [selectedSectionId]="selectedSectionId()"
                  (selectSection)="onSelectSection($event)"
                ></hyperkit-report-section>
              }
            </div>
          </div>
        </div>
      </div>
      <div id="report-details">
        <router-outlet></router-outlet>
      </div>
      <div id="hunt-notes">
        <report-text-block
          title="Notes"
          height="calc(100vh - 110px)"
          [value]="huntView.notes()"
        >
        </report-text-block>
      </div>
    </div>
  </div>
  <div id="top-mitre-container" class="hidden-chart-container"></div>
  <div id="top-actors-container" class="hidden-chart-container"></div>
  <div id="top-threats-container" class="hidden-chart-container"></div>
} @else {
  <p>Loading…</p>
}
